
import SectionBoxes from '@/sections/technology/detail-pages/SectionBoxes.vue'
import SectionStage from '@/sections/technology/detail-pages/SectionStage.vue'
import SectionTabs from '@/sections/technology/detail-pages/SectionTabs.vue'
export default {
  name: 'PageTechnologyDetailPages',
  components: {
    SectionStage,
    SectionBoxes,
    SectionTabs
  },
  transition: {
    name: 'pagetransition',
    mode: 'out-in'
  },
  fetch({ store, route }) {
    let tabPages = [
      'google-analytics',
      'search-ads-360',
      'campaign-manager-360',
      'display-und-video-360',
      'looker-studio-pro'
      // 'google-tag-manager'
    ]
    let promiseItems = [
      store.dispatch('pages/technologie/detail-pages/getMeta', {
        detailFolder: route.params.slug
      }),
      store.dispatch('pages/technologie/detail-pages/getStage', {
        detailFolder: route.params.slug
      }),
      store.dispatch('pages/technologie/detail-pages/getBoxes', {
        detailFolder: route.params.slug
      }),
      store.dispatch('pages/technologie/detail-pages/getContact', {
        detailFolder: route.params.slug
      })
    ]
    if (tabPages.includes(route.params.slug)) {
      promiseItems.push(
        store.dispatch('pages/technologie/detail-pages/getTabs', {
          detailFolder: route.params.slug
        })
      )
    } else {
      store.commit('pages/technologie/detail-pages/setTabs', { data: null })
    }
    return Promise.all(promiseItems)
  },
  head() {
    let headerContent = { title: '', meta: [], link: [] }
    if (this.meta) {
      this.setHeadFields(this.meta)
      headerContent.title = this.metaTitle
      headerContent.meta = this.metaFields
      headerContent.link = this.linkFields
    }
    return headerContent
  },
  computed: {
    meta() {
      return this.$store.getters['pages/technologie/detail-pages/meta']
    },
    stage() {
      return this.$store.getters['pages/technologie/detail-pages/stage']
    },
    boxes() {
      return this.$store.getters['pages/technologie/detail-pages/boxes']
    },
    contact() {
      return this.$store.getters['pages/technologie/detail-pages/contact']
    },
    tabs() {
      return this.$store.getters['pages/technologie/detail-pages/tabs']
    }
  },
  mounted() {
    this.pushPageViewEvent({})
  }
}
